
import { SettingsNavLinks } from "../../components/SettingsNavLinks";
import { ActivationBanner, SwitchAppButton } from "../../components";
import { Card } from "../../components";
import { CheckoutPaymentpage } from "../../components/CheckoutPaymentpage";




export const View = () => {
    return(
    <>
      <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Checkout and Payment Links"
      
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
            <div className="checkout-payment-section-header">
                <strong>Store policies</strong>
                <p>Select details you want to add about your store policies on your payment page.</p>
            </div>
            <CheckoutPaymentpage
            rightcontent="Refund and return policy"
            leftcontent="Display links to your terms of service and privacy policies"
            />
            
             <CheckoutPaymentpage
            rightcontent="Contact Information"
            leftcontent="Display support contact information"
            />
            
              <CheckoutPaymentpage
            rightcontent="Legal policies"
            leftcontent="Display links to your terms of service and privacy policies"
            />
            <div className="checkout-payment-section-header">
                <strong>Payment method options</strong>
                <p>These settings apply to payment pages you create using 
                    SwitchApp Checkout and Payment Links.</p>
             </div>  
            <CheckoutPaymentpage
            rightcontent="Faster checkout"
            leftcontent="Include link to payment gateway and payment methods"
            />
            
            <CheckoutPaymentpage
            rightcontent="Appearance"
            leftcontent="Go to branding settings to upload your icon or logo, and set colors."
            />
            
            <CheckoutPaymentpage
            rightcontent="Public information"
            leftcontent="Go to business details to update your business name."
            />
            
            <CheckoutPaymentpage
            rightcontent="Display gateway"
            leftcontent="Display gateway to customers by region"
            />
              <div className="float-right">
                <SwitchAppButton
                className="switchapp-themed "
                kind="success"  onClick={ (): void =>{("")} }            
                >Cancel</SwitchAppButton>
                <SwitchAppButton
                className="switchapp-themed save-button"
                kind="primary"  onClick={ (): void =>{("")} }            
                >Save    </SwitchAppButton>
            </div>
      </Card>
    </>
    )
}